import AssignButtonLoader from 'components/AssignButtonLoader/AssignButtonLoader';
import queryString from 'query-string';
import { useEffect, useState } from 'react';

import Avatar5 from '../../../assets/img/avatar_5.svg';
import Chat from '../../../assets/img/icons/chat.svg';
import CrossIcon from '../../../assets/img/icons/cross_black.svg';
import Bean from '../../../assets/img/icons/delete.svg';
import BackButtonComponent from '../../../components/BackButtonComponent/BackButtonComponent';
import AddProjectDropdown from '../../../components/CustomDropdown/AddProjectDropdown';
import AddTeamDropdown from '../../../components/CustomDropdown/AddTeamDropdown';
import MembersDropdownStyle from '../../../components/DropdownStyle/MembersDropdownStyle';
import ButtonTextLoader from '../../../components/Loaders/ButtonTextLoader';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../../components/NoDataComponent/NoDataComponent';
import LinearActivityBar from '../../../components/ProgressBar/LinearActivityBar';
import Select from '../../../components/ReactSelectDropdown';
import ToggleButton from '../../../components/ToggleButton/ToggleButton';
import CommonTooltip from '../../../components/Tooltip/CommonTooltip';
import InfoTooltip from '../../../components/Tooltip/InfoTooltip';
import {
  ButtonIcon,
  ColoredButton,
  PrimaryButton,
  WhiteButton,
  WhiteButtonWithIcon,
} from '../../../styledComponents/buttons';
import { HoveredSection, RoundHover } from '../../../styledComponents/clients';
import {
  CardTitle,
  CommonFlex,
  CommonGrid,
  CommonText,
  Container,
  ContentHeader,
  DividerLine,
  InputField,
  InputLabel,
  InputWithLabelSection,
  PageTitle,
  TextInputSection,
} from '../../../styledComponents/common';
import {
  ActivityCard,
  ActivityTextSection,
  AddPayConfigMainSection,
  AddPayConfigTextSection,
  ButtonFlexContainer,
  Dot,
  FlexSection,
  Line,
  PaddingBox,
  PaymentConfigTitle,
  PersonSection,
  PesonActivitySection,
  SingleSection,
  TextLink,
  TextSwitch,
  UpperTitleButtonSection,
  WeeklyLimitSection,
} from '../../../styledComponents/members';
import { currencySymbolMap } from '../../../utils/currencies';
import { getHours, toHHMMSS } from '../../../utils/helper';
import {
  ApprovalSettingsSection,
  CommImageNameComp,
} from '../CommonComponents';
import MemberDeleteModal from '../MemberDeleteModal';
import { t } from 'i18next';

const MemberDetails = props => {
  const [memberDetails, setMemberDetails] = useState(null);
  const [weeklyData, setWeeklyData] = useState(null);
  const [monthlyData, setMonthlyData] = useState(null);
  const [payPeriodValue, setPayPeriodValue] = useState({
    value: '1',
    label: 'Weekly',
  });
  const [payTypeValue, setPayTypeValue] = useState({
    value: '1',
    label: 'Hourly Payment',
  });
  const RoleOptions = [
    //{ value: "owner", label: "Owner" },
    { value: 'admin', label: 'Admin' },
    { value: 'member', label: 'Member' },
  ];
  const payPeriodOptions = [
    { value: '1', label: 'Weekly' },
    { value: '2', label: 'Monthly' },
  ];
  const payTypeOptions = [
    { value: '1', label: 'Hourly Payment' },
    { value: '2', label: 'Fixed Payment' },
  ];
  const [editWeeklyLimit, setEditWeeklyLimit] = useState(false);
  const [weeklyLimitValue, setWeeklyLimitValue] = useState('');
  const [payRateValue, setPayRateValue] = useState('');
  const [billRateValue, setBillRateValue] = useState('');
  const [tabSelect, setTabSelect] = useState('week');
  const colorList = [
    { color: '#9A96F9' },
    { color: '#73C0FF' },
    { color: '#F9828B' },
    { color: '#F9D059' },
  ];
  const [modal, setModal] = useState(false);
  const [projectIndex, setProjectIndex] = useState(-1);
  const [teamIndex, setTeamIndex] = useState(-1);
  const [tooltip, setTooltip] = useState(-1);
  const [showLimitSection, setShowLimitSection] = useState(false);

  const {
    isLoading,
    history,
    location,
    selectedOrganization,
    clearMemberDetailsData,
    getMemberDetails,
    getMemberWeeklyEarning,
    getMemberMonthlyEarning,
    weeklyEarning,
    monthlyEarning,
    removeMember,
    updateMember,
    addTeam,
    assignProject,
    setPaymentConfiguration,
    deleteProjectAssignee,
    removeTeamMember,
    deleteMemberLoading,
    updateMemberLoading,
    teamMemberIsLoading,
    teamListIsLoading,
    getTeamShortList,
    teamList,
    projectAssigneeIsLoading,
    projectListIsLoading,
    getProjectShortList,
    projectList,
    paymentConfigurationLoading,
    updateMemberwiseTimesheetApprovalSettings,
  } = props;

  useEffect(() => {
    return () => {
      clearMemberDetailsData();
    };
  }, []);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      if (location.search) {
        const queryParsed = queryString.parse(location.search);
        let payload = {
          organization_id: selectedOrganization.id,
          user_id: queryParsed.id,
        };
        getMemberDetails(payload);
        getMemberWeeklyEarning(payload);
        getMemberMonthlyEarning(payload);
      }
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (props.memberDetails && props.memberDetails !== null) {
      const details = {
        id: props.memberDetails.id,
        userId: props.memberDetails.user.id,
        name: `${props.memberDetails.user.first_name}${
          props.memberDetails.user.last_name
            ? ` ${props.memberDetails.user.last_name}`
            : ``
        }`,
        email: props.memberDetails.user.email,
        timezone: props.memberDetails.user.timezone,
        avatar: props.memberDetails.user.avatar
          ? props.memberDetails.user.avatar
          : Avatar5,
        role: {
          value: props.memberDetails.role,
          label: `${props.memberDetails.role
            .charAt(0)
            .toUpperCase()}${props.memberDetails.role.slice(1)}`,
        },
        teams: props.memberDetails.teams,
        assignedProjects: props.memberDetails.projects,
        payment: props.memberDetails.payment
          ? props.memberDetails.payment
          : null,
        requireTimesheetApproval:
          props.memberDetails.require_timesheet_approval,
        limitTracking: props.memberDetails.limit_tracking,
        weeklyLimit: props.memberDetails.weekly_tracking_limit,
      };
      setMemberDetails(details);
      if (props.memberDetails.limit_tracking) {
        setShowLimitSection(true);
      }
      if (props.memberDetails.payment) {
        if (props.memberDetails.payment.pay_rate) {
          setPayRateValue(
            (props.memberDetails.payment.pay_rate / 100).toFixed(2),
          );
        }
        if (props.memberDetails.payment.bill_rate) {
          setBillRateValue(
            (props.memberDetails.payment.bill_rate / 100).toFixed(2),
          );
        }
      }
    }
  }, [props.memberDetails]);

  useEffect(() => {
    if (weeklyEarning && weeklyEarning !== null) {
      setWeeklyData(weeklyEarning);
    }
  }, [weeklyEarning]);

  useEffect(() => {
    if (monthlyEarning && monthlyEarning !== null) {
      setMonthlyData(monthlyEarning);
    }
  }, [monthlyEarning]);

  useEffect(() => {
    if (editWeeklyLimit && memberDetails && memberDetails.weeklyLimit) {
      setWeeklyLimitValue(Math.floor(memberDetails.weeklyLimit / 3600));
    } else if (!editWeeklyLimit) {
      setWeeklyLimitValue('');
    }
  }, [editWeeklyLimit]);

  const toggleDeleteModal = () => {
    setModal(!modal);
  };

  const handleDeleteMember = () => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      memberDetails &&
      memberDetails.userId
    ) {
      let payload = {
        organization_id: selectedOrganization.id,
        user_id: memberDetails.userId,
      };
      removeMember(payload);
      setTimeout(() => {
        toggleDeleteModal();
        history.push('/user/members');
      }, 300);
    }
  };

  const onRoleChange = e => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      memberDetails &&
      memberDetails.userId &&
      memberDetails.role
    ) {
      let payload = {
        organization_id: selectedOrganization.id,
        user_id: memberDetails.userId,
      };
      if (
        (memberDetails.role.value === 'admin' ||
          memberDetails.role.value === 'project manager') &&
        e.value === 'member'
      ) {
        payload.is_admin = false;
        updateMember(payload);
      } else if (
        (memberDetails.role.value === 'member' ||
          memberDetails.role.value === 'project manager') &&
        e.value === 'admin'
      ) {
        payload.is_admin = true;
        updateMember(payload);
      }
    }
  };

  const onTabSwitch = value => {
    setTabSelect(value);
  };

  const onWeeklyLimitChange = e => {
    const { value } = e.target;

    setWeeklyLimitValue(value);
  };

  const onPayPeriodChange = e => {
    setPayPeriodValue(e);
  };
  const onPayTypeChange = e => {
    setPayTypeValue(e);
  };

  const onPayRateChange = e => {
    const { value } = e.target;
    setPayRateValue(value);
  };
  const onBillRateChange = e => {
    const { value } = e.target;
    setBillRateValue(value);
  };

  const handleAddTeam = team => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      team &&
      team.id &&
      memberDetails &&
      memberDetails.userId
    ) {
      let payload = {
        organization_id: selectedOrganization.id,
        team_id: team.id,
        user_id: memberDetails.userId,
        getMemberData: true,
      };
      addTeam(payload);
    }
  };

  const handleAssignProject = project => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      memberDetails &&
      memberDetails.userId &&
      project &&
      project.id
    ) {
      let payload = {
        organization_id: selectedOrganization.id,
        project_id: project.id,
        user_id: memberDetails.userId,
        getMemberData: true,
      };
      assignProject(payload);
    }
  };

  const cancelFunction = () => {
    console.log('cancel submit');
  };

  const handleSavePayment = () => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      memberDetails &&
      memberDetails.id &&
      memberDetails.userId &&
      payRateValue
    ) {
      const payload = {
        organization_id: selectedOrganization.id,
        user_id: memberDetails.userId,
        pay_rate: parseInt(payRateValue * 100),
        currency:
          (selectedOrganization.configuration &&
            selectedOrganization.configuration.currency) ||
          'USD',
      };
      if (billRateValue) {
        payload.bill_rate = parseInt(billRateValue * 100);
      }
      setPaymentConfiguration(payload);
    }
  };

  const handleSaveWeeklyLimit = limitTracking => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      memberDetails &&
      memberDetails.userId
    ) {
      const payload = {
        organization_id: selectedOrganization.id,
        user_id: memberDetails.userId,
      };
      if (limitTracking) {
        payload.limit_tracking = true;
        payload.weekly_tracking_limit = weeklyLimitValue * 3600;
      } else if (!limitTracking) {
        payload.limit_tracking = false;
        payload.weekly_tracking_limit = 0;
      }
      updateMember(payload);
      setTimeout(() => {
        setEditWeeklyLimit(false);
      }, 400);
    }
  };

  const onProjectHover = index => {
    setProjectIndex(index);
  };

  const onTeamHover = index => {
    setTeamIndex(index);
  };

  const tooltipChange = index => {
    setTooltip(index);
  };

  const handleDeleteProject = projectId => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      projectId &&
      memberDetails &&
      memberDetails.userId
    ) {
      let payload = {
        organization_id: selectedOrganization.id,
        project_id: projectId,
        user_id: memberDetails.userId,
      };
      deleteProjectAssignee(payload);
    }
  };

  const handleDeleteTeam = teamId => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      teamId &&
      memberDetails &&
      memberDetails.userId
    ) {
      let payload = {
        organization_id: selectedOrganization.id,
        team_id: teamId,
        user_id: memberDetails.userId,
        fromMember: true,
      };
      removeTeamMember(payload);
    }
  };

  const updateTimesheetApprovalSettings = (memberId, value) => {
    if (selectedOrganization && selectedOrganization.id && memberId) {
      const payload = {
        organization_id: selectedOrganization.id,
        settings_id: memberId,
        require_timesheet_approval: value,
      };
      updateMemberwiseTimesheetApprovalSettings(payload);
    }
  };

  return (
    <div className="content">
      <PageTitle>Members</PageTitle>
      <ContentHeader>
        <BackButtonComponent
          onClick={() => history.push('/user/members/all')}
          subTitle="Back to all members"
        />
      </ContentHeader>
      <Container style={{ padding: `30px 0` }}>
        {isLoading ? (
          <ComponentCircleLoader />
        ) : memberDetails && memberDetails !== null ? (
          <>
            <UpperTitleButtonSection>
              <CardTitle>Member Details</CardTitle>
              {selectedOrganization &&
                selectedOrganization.role !== 'member' && (
                  <UpperTitleButtonSection gap="0" padding="0">
                    {memberDetails.role.value !== 'owner' && (
                      <WhiteButtonWithIcon
                        type="delete"
                        fontSize="14px"
                        onClick={() => toggleDeleteModal()}
                      >
                        <ButtonIcon src={Bean} alt="" width="18px" />
                        Delete Member
                      </WhiteButtonWithIcon>
                    )}

                    <MemberDeleteModal
                      isOpen={modal}
                      toggle={toggleDeleteModal}
                      handleDelete={handleDeleteMember}
                      isLoading={deleteMemberLoading}
                    />
                  </UpperTitleButtonSection>
                )}
            </UpperTitleButtonSection>

            <SingleSection margin="0 0 20px 0">
              <PersonSection>
                <CommImageNameComp
                  imgSource={memberDetails.avatar}
                  name={memberDetails.name}
                  email={memberDetails.email}
                  size="70px"
                />
                <InputWithLabelSection style={{ justifyContent: 'flex-end' }}>
                  {/* <InfoTooltip
                      mainText="Role"
                      toolTipText="Project Type Sed ut perspiciatis unde omnis iste natus error sit"
                    /> */}
                  <InputLabel>Role</InputLabel>
                  {selectedOrganization &&
                  selectedOrganization.role !== 'member' &&
                  memberDetails.role.value !== 'owner' ? (
                    <>
                      {updateMemberLoading ? (
                        <AssignButtonLoader
                          padding="9px 10px"
                          borderColor="rgb(228, 231, 235)"
                          width="150px"
                        />
                      ) : (
                        <Select
                          isSearchable
                          value={memberDetails.role}
                          options={RoleOptions}
                          onChange={e => {
                            onRoleChange(e);
                          }}
                          styles={MembersDropdownStyle({
                            minHeight: '40px',
                            minWidth: '150px',
                          })}
                        />
                      )}
                    </>
                  ) : (
                    <CommonText>{memberDetails.role.label}</CommonText>
                  )}
                </InputWithLabelSection>
              </PersonSection>
              {memberDetails.timezone && (
                <CommonFlex gap="5px" margin="10px 0 20px">
                  <CommonText label fontWeight="500" fontSize="13px">
                    Timezone:
                  </CommonText>
                  <CommonText fontSize="13px">
                    UTC ({memberDetails.timezone.offset}){' '}
                    {memberDetails.timezone.tz}
                  </CommonText>
                </CommonFlex>
              )}
              <ActivityCard>
                <FlexSection>
                  <TextSwitch
                    onClick={() => onTabSwitch('week')}
                    tabSelect={tabSelect}
                    index={'week'}
                  >
                    This Week
                  </TextSwitch>
                  <TextSwitch
                    onClick={() => onTabSwitch('month')}
                    tabSelect={tabSelect}
                    index={'month'}
                  >
                    Month
                  </TextSwitch>
                </FlexSection>
                <PesonActivitySection
                  earned={
                    tabSelect === 'week'
                      ? weeklyData && weeklyData.total_earned > 0
                      : monthlyData && monthlyData.total_earned > 0
                  }
                >
                  <ActivityTextSection>
                    <CommonText fontSize="16px" title>
                      {tabSelect === 'week'
                        ? weeklyData &&
                          getHours(toHHMMSS(weeklyData.total_time))
                        : monthlyData &&
                          getHours(toHHMMSS(monthlyData.total_time))}
                    </CommonText>
                    <CommonText $label fontWeight="500">
                      Time Worked
                    </CommonText>
                  </ActivityTextSection>
                  <ActivityTextSection>
                    <FlexSection>
                      <LinearActivityBar
                        percent={
                          tabSelect === 'week'
                            ? weeklyData &&
                              (weeklyData.avg_activity * 100).toFixed(2)
                            : monthlyData &&
                              (monthlyData.avg_activity * 100).toFixed(2)
                        }
                      />
                      <CommonText fontSize="16px" title>
                        {tabSelect === 'week'
                          ? `${
                              weeklyData
                                ? (weeklyData.avg_activity * 100).toFixed(2)
                                : '0'
                            }%`
                          : `${
                              monthlyData
                                ? (monthlyData.avg_activity * 100).toFixed(2)
                                : '0'
                            }%`}
                      </CommonText>
                    </FlexSection>
                    <CommonText $label fontWeight="500">
                      Activity
                    </CommonText>
                  </ActivityTextSection>
                  <ActivityTextSection>
                    <CommonText fontSize="16px" title>
                      {tabSelect === 'week'
                        ? memberDetails.payment &&
                          memberDetails.payment.pay_rate &&
                          weeklyData
                          ? `${
                              currencySymbolMap[memberDetails.payment.currency]
                            } ${weeklyData.total_earned}`
                          : `N/A`
                        : memberDetails.payment &&
                          memberDetails.payment.pay_rate &&
                          monthlyData
                        ? `${
                            currencySymbolMap[memberDetails.payment.currency]
                          } ${monthlyData.total_earned}`
                        : `N/A`}
                    </CommonText>
                    <CommonText $label fontWeight="500">
                      Earned
                    </CommonText>
                  </ActivityTextSection>
                  {/* {tabSelect === "week" ? (
                      weeklyData && weeklyData.total_earned > 0 ? (
                        <CommonColorButton
                          padding="13px 25px"
                          style={{ margin: `auto 0` }}
                        >
                          View Payment Info
                        </CommonColorButton>
                      ) : null
                    ) : monthlyData && monthlyData.total_earned > 0 ? (
                      <CommonColorButton
                        padding="13px 25px"
                        style={{ margin: `auto 0` }}
                      >
                        View Payment Info
                      </CommonColorButton>
                    ) : null} */}
                </PesonActivitySection>
                {/* <FlexSection>
                    <TextLink>View Timesheet</TextLink>
                    <Dot />
                    <TextLink>View Activity</TextLink>
                  </FlexSection> */}
              </ActivityCard>
            </SingleSection>
            <SingleSection>
              <CommonText $label>Teams he works for</CommonText>
              <ButtonFlexContainer>
                {memberDetails.teams.map((team, index) => (
                  <ColoredButton
                    bgColor={colorList[index > 3 ? index % 4 : index].color}
                    key={index}
                    onMouseEnter={() => onTeamHover(index)}
                    onMouseLeave={() => onTeamHover(-1)}
                    style={{ position: 'relative' }}
                  >
                    <span
                      onClick={() => {
                        if (
                          selectedOrganization &&
                          selectedOrganization.role !== 'member'
                        ) {
                          history.push(`/user/team-details?id=${team.id}`);
                        }
                      }}
                    >
                      {team.name}
                    </span>
                    {teamIndex === index &&
                      selectedOrganization &&
                      selectedOrganization.role !== 'member' && (
                        <HoveredSection
                          style={{
                            gridTemplateColumns: '1fr',
                            right: '5px',
                          }}
                        >
                          <RoundHover
                            onMouseEnter={() => tooltipChange(1)}
                            onMouseLeave={() => tooltipChange(-1)}
                            onClick={() => handleDeleteTeam(team.id)}
                          >
                            <img src={CrossIcon} alt="cross" />
                            {tooltip === 1 && (
                              <CommonTooltip
                                tooltipText="Remove Member"
                                left="-58px"
                                top="-40px"
                                width="140px"
                              />
                            )}
                          </RoundHover>
                        </HoveredSection>
                      )}
                  </ColoredButton>
                ))}
                {teamMemberIsLoading ? (
                  <AssignButtonLoader />
                ) : selectedOrganization &&
                  selectedOrganization.role !== 'member' ? (
                  <AddTeamDropdown
                    isLoading={teamListIsLoading}
                    selectedOrganization={selectedOrganization}
                    assignedTeams={memberDetails.teams}
                    getTeamList={getTeamShortList}
                    updateState={handleAddTeam}
                    teamsList={teamList}
                    buttonPadding="10px 15px"
                  />
                ) : memberDetails.teams && memberDetails.teams.length === 0 ? (
                  <CommonText>No Teams</CommonText>
                ) : null}
              </ButtonFlexContainer>
            </SingleSection>
            <SingleSection>
              <CommonText $label>Assigned Projects</CommonText>
              <ButtonFlexContainer>
                {memberDetails.assignedProjects.map((project, index) => (
                  <WhiteButton
                    type="cancel"
                    key={index}
                    onMouseEnter={() => onProjectHover(index)}
                    onMouseLeave={() => onProjectHover(-1)}
                    style={{ position: 'relative' }}
                  >
                    <span
                      onClick={() => {
                        if (
                          selectedOrganization &&
                          selectedOrganization.role !== 'member'
                        ) {
                          history.push(
                            `/user/project-details?id=${project.id}&type=${
                              project.is_active ? 'active' : 'archived'
                            }`,
                          );
                        }
                      }}
                    >
                      {project.name}
                    </span>
                    {projectIndex === index &&
                      selectedOrganization &&
                      selectedOrganization.role !== 'member' && (
                        <HoveredSection
                          style={{
                            gridTemplateColumns: '1fr',
                            right: '5px',
                          }}
                        >
                          <RoundHover
                            onMouseEnter={() => tooltipChange(1)}
                            onMouseLeave={() => tooltipChange(-1)}
                            onClick={() => handleDeleteProject(project.id)}
                          >
                            <img src={CrossIcon} alt="cross" />
                            {tooltip === 1 && (
                              <CommonTooltip
                                tooltipText="Remove Member"
                                left="-58px"
                                top="-40px"
                                width="140px"
                              />
                            )}
                          </RoundHover>
                        </HoveredSection>
                      )}
                  </WhiteButton>
                ))}
                {projectAssigneeIsLoading ? (
                  <AssignButtonLoader />
                ) : selectedOrganization &&
                  selectedOrganization.role !== 'member' ? (
                  <AddProjectDropdown
                    isLoading={projectListIsLoading}
                    selectedOrganization={selectedOrganization}
                    assignedProjects={memberDetails.assignedProjects}
                    getProjectList={getProjectShortList}
                    updateState={handleAssignProject}
                    projectsList={projectList}
                    buttonPadding="9px 15px"
                  />
                ) : memberDetails.assignedProjects &&
                  memberDetails.assignedProjects.length === 0 ? (
                  <CommonText>No Projects</CommonText>
                ) : null}
              </ButtonFlexContainer>
            </SingleSection>

            <SingleSection margin="10px 0 20px">
              <ApprovalSettingsSection
                margin="0"
                hasTooltip
                memberId={memberDetails.id}
                active={memberDetails.requireTimesheetApproval}
                handleChange={updateTimesheetApprovalSettings}
                isAdmin={
                  selectedOrganization && selectedOrganization.role !== 'member'
                }
              />
            </SingleSection>

            <SingleSection>
              <ActivityTextSection>
                <CommonText $label>Payment</CommonText>
                {memberDetails && memberDetails.payment ? (
                  <CommonText>
                    {memberDetails.payment.currency} (
                    {currencySymbolMap[memberDetails.payment.currency]}){' '}
                    {(memberDetails.payment.pay_rate / 100).toFixed(2)} / hour
                  </CommonText>
                ) : (
                  <CommonText>Payment not set</CommonText>
                )}
              </ActivityTextSection>
            </SingleSection>
            {selectedOrganization && selectedOrganization.role !== 'member' && (
              <SingleSection>
                <AddPayConfigMainSection>
                  {/* <TextInputSection>
                        <InfoTooltip
                          mainText="Pay Period"
                          toolTipText="Project Type Sed ut perspiciatis unde omnis iste natus error sit"
                        />
                        <Select
                          isSearchable
                          value={payPeriodValue}
                          options={payPeriodOptions}
                          onChange={(e) => {
                            onPayPeriodChange(e);
                          }}
                          styles={MembersDropdownStyle()}
                        />
                      </TextInputSection>
                      <TextInputSection>
                        <InfoTooltip
                          mainText="Payment Type"
                          toolTipText="Project Type Sed ut perspiciatis unde omnis iste natus error sit"
                        />
                        <Select
                          isSearchable
                          value={payTypeValue}
                          options={payTypeOptions}
                          onChange={(e) => {
                            onPayTypeChange(e);
                          }}
                          styles={MembersDropdownStyle()}
                        />
                      </TextInputSection> */}
                  <TextInputSection>
                    <InfoTooltip
                      mainText="Pay Rate"
                      toolTipText="Pay rate is used to manage your employee's payroll"
                      title
                      label
                    />
                    <CommonGrid columns="60px auto" gap="10px">
                      <CommonText>
                        {selectedOrganization &&
                          selectedOrganization.configuration &&
                          selectedOrganization.configuration.currency &&
                          `${selectedOrganization.configuration.currency} (${
                            currencySymbolMap[
                              selectedOrganization.configuration.currency
                            ]
                          })`}
                      </CommonText>
                      <InputField
                        height="36px"
                        style={{ width: '90%' }}
                        type="text"
                        placeholder="00"
                        value={payRateValue}
                        onChange={e => onPayRateChange(e)}
                      />
                    </CommonGrid>
                  </TextInputSection>
                  <TextInputSection>
                    <InfoTooltip
                      mainText="Bill Rate"
                      toolTipText="Bill rate is used to invoice your client"
                      top="-40px"
                      title
                      label
                    />
                    <CommonGrid columns="60px auto" gap="10px">
                      <CommonText>
                        {selectedOrganization &&
                          selectedOrganization.configuration &&
                          selectedOrganization.configuration.currency &&
                          `${selectedOrganization.configuration.currency} (${
                            currencySymbolMap[
                              selectedOrganization.configuration.currency
                            ]
                          })`}
                      </CommonText>
                      <InputField
                        height="36px"
                        style={{ width: '90%' }}
                        type="text"
                        placeholder="00"
                        value={billRateValue}
                        onChange={e => onBillRateChange(e)}
                      />
                    </CommonGrid>
                  </TextInputSection>
                  <PrimaryButton
                    height="36px"
                    style={{ alignSelf: 'flex-end' }}
                    padding={paymentConfigurationLoading ? '0 15px' : '0 30px'}
                    onClick={() => handleSavePayment()}
                    disabled={!payRateValue}
                  >
                    {paymentConfigurationLoading ? (
                      <ButtonTextLoader loadingText="Saving" fontSize="13px" />
                    ) : (
                      'Save'
                    )}
                  </PrimaryButton>
                </AddPayConfigMainSection>
                {/* <ButtonSection>
                    <Button save={false} onClick={() => cancelFunction()}>
                      {t('cancel')}
                    </Button>
                    <Button save onClick={() => handleSave()}>
                      Save
                    </Button>
                  </ButtonSection> */}
              </SingleSection>
            )}

            <DividerLine margin="25px 0 0" />

            <SingleSection margin="25px 0 0">
              <ActivityTextSection gap="12px">
                <CommonFlex gap="15px">
                  <CommonText $label>Weekly Limit</CommonText>
                  {selectedOrganization &&
                    selectedOrganization.role !== 'member' && (
                      <ToggleButton
                        active={showLimitSection}
                        handleClick={() => {
                          if (memberDetails.limitTracking && showLimitSection) {
                            handleSaveWeeklyLimit(false);
                          }
                          setShowLimitSection(!showLimitSection);
                        }}
                      />
                    )}
                </CommonFlex>

                {showLimitSection &&
                selectedOrganization &&
                selectedOrganization.role !== 'member' ? (
                  <ActivityTextSection gap="15px">
                    <CommonFlex gap="40px">
                      {editWeeklyLimit ? (
                        <CommonFlex gap="13px">
                          <InputField
                            style={{ width: `70px` }}
                            height="36px"
                            type="number"
                            placeholder="0"
                            min={0}
                            value={weeklyLimitValue}
                            onChange={e => onWeeklyLimitChange(e)}
                          />
                          <CommonText>Hours/ Week</CommonText>
                        </CommonFlex>
                      ) : (
                        <CommonText>
                          {memberDetails.weeklyLimit
                            ? `${Math.floor(
                                memberDetails.weeklyLimit / 3600,
                              )} Hours/ Week`
                            : `No weekly limit is set`}
                        </CommonText>
                      )}

                      {editWeeklyLimit ? (
                        <CommonFlex gap="12px">
                          <WhiteButton
                            height="36px"
                            padding="0 15px"
                            onClick={() => setEditWeeklyLimit(false)}
                          >
                            {t('cancel')}
                          </WhiteButton>
                          <PrimaryButton
                            disabled={
                              !weeklyLimitValue || weeklyLimitValue <= 0
                            }
                            height="36px"
                            padding="0 15px"
                            onClick={() => handleSaveWeeklyLimit(true)}
                          >
                            Set Limit
                          </PrimaryButton>
                        </CommonFlex>
                      ) : (
                        <WhiteButton
                          height="36px"
                          padding="0 15px"
                          onClick={() => setEditWeeklyLimit(true)}
                        >
                          Edit Limit
                        </WhiteButton>
                      )}
                    </CommonFlex>
                    {memberDetails &&
                      memberDetails.payment &&
                      memberDetails.payment.pay_rate &&
                      memberDetails.limitTracking && (
                        <CommonText fontSize="12px" $label fontWeight="500">
                          {currencySymbolMap[memberDetails.payment.currency]}{' '}
                          {(
                            (memberDetails.payment.pay_rate *
                              (weeklyLimitValue
                                ? weeklyLimitValue
                                : memberDetails.weeklyLimit
                                ? Math.floor(memberDetails.weeklyLimit / 3600)
                                : 0)) /
                            100
                          ).toFixed(2)}{' '}
                          / Week
                        </CommonText>
                      )}
                  </ActivityTextSection>
                ) : (
                  <CommonText>
                    {memberDetails.weeklyLimit
                      ? `${Math.floor(
                          memberDetails.weeklyLimit / 3600,
                        )} Hours/ Week`
                      : `No weekly limit is set`}
                  </CommonText>
                )}
              </ActivityTextSection>
            </SingleSection>
          </>
        ) : (
          <NoDataComponent title="Sorry! could not fetch member details. Please try again!" />
        )}
      </Container>
    </div>
  );
};

export default MemberDetails;
